import {Injectable} from "@angular/core";
import {forkJoin, Observable} from "rxjs";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {fromPromise} from "rxjs/internal-compatibility";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {DxNciDictionary} from "../domain/dx-nci-dictionary";
import {BdpkConfigService} from "../../bdpk-common/services/bdpk-config.service";


@Injectable()
export class DxNciService {

  constructor(private _mapper: DxObjectMapper,
              private _configService: BdpkConfigService,
              private _http: DxHttpDispatcher) {

  }

  /** кэш справочников с бэкенда */
  private _dictsCache: Map<string, DxNciDictionary> = new Map();

  /** Получает элементы замоканных на фронте справочников */
  // TODO: Удалить как только все справочники будут переведены на фронт
  public fetchDictionary(ident: string): Observable<DxNciDictionary> {
    const promise = new Promise<DxNciDictionary>((resolve, reject) => {
      this._http
        .get('catalogs')
        .subscribe(response => {
          const dictsMap = this._mapper.deserializeASMap<String, DxNciDictionary>(response.body, String, DxNciDictionary);
          if(dictsMap.has(ident)) {
            const dict = dictsMap.get(ident);
            dict.fillIndex();
            resolve(dict);
          } else {
            reject(`Справочник НСИ с идентом ${ident} не найден!`);
          }
        }, errorResponse => {
          reject(DxHttpDispatcher.handleHttpError(errorResponse));
        });
    });
    return fromPromise<DxNciDictionary>(promise);
  }

  /** получает значение всех элементов справочника с бэкенда через единый интерфейс */
  public fetchBackendDictionary(ident: string, cache: boolean = true): Observable<DxNciDictionary> {
    const promise = new Promise<DxNciDictionary>((resolve, reject) => {
      if (cache && this._dictsCache.has(ident)) {
        resolve(this._dictsCache.get(ident));
      } else {
        const path = this._configService.pitBackendNciEndpoint + '/dictionaries/' + ident + '/items';
        this._http
          .get(path)
          .subscribe(response => {
            let dict = this._mapper.deserialize(response.body, DxNciDictionary);
            dict.fillIndex();
            this._dictsCache.set(ident, dict);
            resolve(dict);
          }, errorResponse => {
            reject(DxHttpDispatcher.handleHttpError(errorResponse));
          });
      }
    });
    return fromPromise<DxNciDictionary>(promise);
  }


  public fetchDictionaries(idents: string[]): Observable<DxNciDictionary[]> {
    const dicts: DxNciDictionary[] = [];
    const asyncTasks: Observable<any>[] = [];
    const unicIdents: string[] = Array.from(new Set(idents));
    unicIdents.forEach(item => asyncTasks.push(this.fetchBackendDictionary(item)));
    const promise = new Promise<DxNciDictionary[]>((resolve, reject) => {
      forkJoin(asyncTasks).subscribe(response => {
        response.forEach(dict => dicts.push(dict));
        resolve(dicts);
      }, errorResponse => {
          reject(DxHttpDispatcher.handleHttpError(errorResponse));
      });
    });
    return fromPromise<DxNciDictionary[]>(promise);
  }
}
